import { getAxiosInstance } from "../http";

import { Partner } from "../models"

export class PartnerService {

    static getPartners = async (prefix?: string): Promise<Partner[]> => {

        const instance = getAxiosInstance()

        const url = prefix ? prefix + '/partners' : 'partners'

        const response = await instance.get(url)

        const result = response.data.map((s: any) => Partner.fromJSON(s))

        return result
    }


    static createPartner = async (partner: Partner, prefix?: string): Promise<Partner> => {

        const instance = getAxiosInstance()

        const url = prefix ? prefix + '/partners' : 'partners'

        const response = await instance.post(url, Partner.toJSON(partner))

        return Partner.fromJSON(response.data)
    }

}